import Location from 'app-location'

export const TokensEndPoint = new Location('/v1/log_tokens')
